import { defineStore } from "pinia";

export const useUserPath = defineStore({
    id: "zhongsheng-path",
    state: (): { fromPath: string } => ({
        fromPath: ""
    }),
    getters: {},
    actions: {
        setPath(path: string) {
            this.fromPath = path;
        }
    }
});
